/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Mcp_Tool_TitleInputs */



/**
* | output |
* | --- |
* | "Run external tool?" |
*
* @param {Chat_Mcp_Tool_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_mcp_tool_title = /** @type {((inputs?: Chat_Mcp_Tool_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Mcp_Tool_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Externes Tool ausführen?")
	return /** @type {LocalizedString} */ ("Run external tool?")
});